import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AnimatedDialog from "../../Common/AnimatedDialog";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CityPropertyActions from "../../../store/actions/CityProperty";
import * as GenSettingActions from "../../../store/actions/GenSetting";
import styles from "../../../static/styles/common";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import black from "sushiweb/tokens/color/black";
import { isEmpty } from "../../../utils";
import { isValidated } from "../HelperFunctions";

const useStyles = makeStyles((theme) => ({
  jsonContainerBorder: {
    border: "0.063rem solid grey",
    borderRadius: "0.675rem",
    borderColor: "#CFCFCF",
  },
}));

const mandatoryFields = ["rule_name", "order_selector", "priority"];

const EditRuleFormModal = (props) => {
  const classes = useStyles();
  const {
    handleModalClose,
    modalState,
    heading,
    setActiveRule,
    activeRule,
    activeGenSetting,
    activeCityProperty,
    finalConfig,
    createdRule,
  } = props;
  const [initialState, setInitialState] = useState({
    rule_name: "",
    order_selector: {},
    priority: "",
  });
  const [formError, setFormError] = useState("");

  useEffect(() => {
    if (activeRule) {
      const values = { ...initialState };
      Object.keys(values).map((key) => {
        values[key] = activeRule[key];
      });
      setInitialState(values);
    }
  }, [activeRule]);

  const handleChangeOrderSelector = (key, e) => {
    const value = e.jsObject;
    if (value != undefined) {
      const values = { ...initialState };
      values[key] = value;
      setInitialState(values);
    }
  };

  const handleChange = (key, val) => {
    const values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    let validatedState = isValidated(initialState, mandatoryFields);
    if (validatedState === "validated") {
      var isAltered = false;
      // validate the form input and setFormerror if there is any
      //update activeRUle or activeCityProperty or activeGensetting depending on where it was inherited from
      isAltered =
        activeRule.order_selector == initialState.order_selector &&
        activeRule.priority == parseInt(initialState.priority)
          ? false
          : true;

      if (isAltered) {
        activeRule.is_modified = true;
        activeRule.order_selector = initialState.order_selector;
        activeRule.priority = parseInt(initialState.priority);
        if (!isEmpty(activeCityProperty)) {
          activeRule.is_city_property = true;
        }
        // update finalconfig
        let newfinalConfig = JSON.parse(JSON.stringify(finalConfig));
        newfinalConfig = newfinalConfig.map((rule) => {
          if (rule.rule_name == activeRule.rule_name) {
            rule.order_selector = activeRule.order_selector;
            rule.priority = activeRule.priority;
            rule.is_modified = activeRule.is_modified;
            if (activeRule.is_city_property != undefined) {
              rule.is_city_property = true;
            }
          }
          return rule;
        });
        newfinalConfig.sort((a, b) =>
          a.priority < b.priority ? 1 : b.priority < a.priority ? -1 : 0
        );
        props.setFinalConfig({
          rules: newfinalConfig,
        });
        // check if newly created RUle is being edited
        if (
          !isEmpty(createdRule) &&
          activeRule.is_new != undefined &&
          createdRule.rule_name == activeRule.rule_name
        ) {
          createdRule.order_selector = activeRule.order_selector;
          createdRule.priority = activeRule.priority;
          props.setcreatedRule(createdRule);
        }
        // check if city is selected
        else if (!isEmpty(activeCityProperty)) {
          if (activeCityProperty.value.rules == undefined) {
            activeCityProperty.value.rules = [activeRule];
          } else {
            var found = false;
            let newCityProperty = activeCityProperty.value.rules.map((rule) => {
              if (rule.rule_name == activeRule.rule_name) {
                found = true;
                rule = activeRule;
              }
              return rule;
            });
            activeCityProperty.value.rules = newCityProperty;
            if (!found) {
              activeCityProperty.value.rules.push(activeRule);
            }
          }
          props.setActiveCityProperty(activeCityProperty);
        } else {
          // if none of the above is true
          let newGenSetting = activeGenSetting.value.rules.map((rule) => {
            if (rule.rule_name == activeRule.rule_name) {
              rule = activeRule;
            }
            return rule;
          });
          activeGenSetting.value.rules = newGenSetting;
          props.setActiveGenSetting(activeGenSetting);
        }
      }
      handleModalClose();
    } else {
      setFormError(validatedState);
    }
  };

  return (
    <AnimatedDialog
      header={true}
      heading={heading}
      isVisible={!!modalState}
      permission={true}
      acceptLabel={"Submit"}
      rejectLabel={"Cancel"}
      handleAccept={handleSubmit}
      handleReject={handleModalClose}
      id="editruleformmodal"
    >
      <div id="edit-rule-form">
        <Input
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth={true}
          value={initialState.rule_name}
          disabled
          label="Rule Name"
        />
        <Input
          type="number"
          borderColor={styles.primaryColor}
          id="sushi-input"
          fullWidth={true}
          onChange={(e) => handleChange("priority", e)}
          value={initialState.priority}
          label="Priority"
        />
        <h5>Order Selector</h5>
        <div className={classes.jsonContainerBorder}>
          <JSONInput
            id="json-input"
            placeholder={initialState.order_selector}
            locale={locale}
            height="auto"
            width="auto"
            onChange={(e) => handleChangeOrderSelector("order_selector", e)}
            colors={{
              colon: "#2781E7",
              string: "#FA7921",
              number: "#4B9B42",
              background: "#00000000",
              keys: "#1E1E1E",
              default: black,
            }}
            confirmGood={false}
          />
        </div>
      </div>
      {formError.length > 0 ? (
        <div className={"error-state"}>{"*" + formError}</div>
      ) : (
        ""
      )}
    </AnimatedDialog>
  );
};

function mapStateToProps(state) {
  const { GenSetting, CityProperty } = state;
  return {
    activeGenSetting: GenSetting.activeGenSetting,
    activeCityProperty: CityProperty.activeCityProperty,
    finalConfig: GenSetting.finalConfig,
    createdRule: GenSetting.activeRule,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setFinalConfig: bindActionCreators(
      GenSettingActions.setFinalConfig,
      dispatch
    ),
    setActiveCityProperty: bindActionCreators(
      CityPropertyActions.setActiveCityProperty,
      dispatch
    ),
    setActiveGenSetting: bindActionCreators(
      GenSettingActions.setActiveGenSetting,
      dispatch
    ),
    setcreatedRule: bindActionCreators(
      GenSettingActions.setActiveRule,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRuleFormModal);
